import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose, lifecycle, mapProps } from 'recompose';
import { Layout } from 'antd';

import Routes from './Routes';
import { actions as authActions } from 'ducks/auth';
import HeaderNav from 'components/Nav/HeaderNav';
import SiderNav from 'components/Nav/SiderNav';
import styled from 'styled-components';
import { omit } from 'lodash-es';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Bangkok');

const { Content, Footer } = Layout;

const enhance = compose(
  withRouter,
  connect(
    state => ({
      isShowMenu: state.router.location.pathname !== '/login'
    }),
    { ...authActions }
  ),
  lifecycle({
    async componentDidMount() {
      const data = await this.props.getMe();
      if (data && data.user && !data.user.is_admin) {
        this.props.logout();
      }
    }
  }),
);

const omitProps = keys => mapProps(props => omit(props, keys));

const ContentLayout = styled(omitProps(['hasSider'])(Layout))`
  min-height: 100vh;
  @media (min-width: 769px) {
    padding-left: ${props => (props.hasSider ? '200px' : '0')};
  }
`;

const ContentMain = styled(Content)`
  padding: 24px 16px;
  @media (max-width: 768px) {
    padding: 48px 10px;
  }
`;

const App = props => (
  <main>
    <Layout>
      { props.isShowMenu &&
        <SiderNav />
      }
      <ContentLayout hasSider={props.isShowMenu} >
        { props.isShowMenu &&
          <HeaderNav />
        }
        <ContentMain>
          <Routes />
        </ContentMain>
        {props.isShowMenu && <Footer style={{ textAlign: 'center' }}>
          TakeMeTour Admin powered by Ant Design ©2017 - {moment().format('YYYY')}
        </Footer>}
      </ContentLayout>
    </Layout>
  </main>
);

export default enhance(App);



// WEBPACK FOOTER //
// ./src/App.js